/*!
=========================================================
* 売掛金管理
=========================================================
*/
import React from "react";

import {
  Container,
  Button,
  Row, Col,
  Label,
  Table,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import CustomTd from '../ViewParts/CustomTd';
import Request from '../../common/Request';
import InputSelect from '../FormParts/InputSelect'
import InputNumber from '../FormParts/InputNumber'
import DialogBase from '../Base/DialogBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import Format from '../../common/Format';
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';
import InputText from '../FormParts/InputText';
import InputDatetime from '../FormParts/InputDatetime';
import InputCheckBox from '../FormParts/InputCheckBox';
import InputRadio from '../FormParts/InputRadio'
import WithRole from '../FormParts/ButtonWithRole';
import CsvDownloader from "react-csv-downloader"
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import {
  cst_accounts_receivable_status,
  cst_receivable_collect_type,
  new_cst_receivable_collect_type,
  cst_receivable_collect_bank_type,
  cst_accounts_receivable_collection_action,
  cst_extension_remind_send_flag_action
} from '../../variables/codes_map';
import { GetMessage, getErrorCodes } from '../../variables/message';
import { ACCOUNTS_RECEIVABLE_LIST, ACCOUNTS_RECEIVABLE_LIST_PER_CUSTOMER } from '../../variables/csv'
import GoogleDrive from "../../common/GoogleDrive";
import format_url from '../../variables/format_url';
import FormatCode from "../../common/FormatCode";
import { sortByNumber } from "../../common/Sort"
import AlertAndpadModal from '../ViewParts/AlertAndpadModal';

const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '請求ID',accessor: 'ACCOUNTS_RECEIVABLE__invoice_natural_id',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '顧客名',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '現場名',accessor: 'PROJECT__site_name',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '回収済フラグ',accessor: 'ACCOUNTS_RECEIVABLE__accounts_receivable_collection_flag',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '売掛金回収状況',accessor: '___JOIN_accounts_receivable_status',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '仕入実施日',accessor: 'ACCOUNTS_RECEIVABLE__invoice_payment_finish_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '支払期限日',accessor: 'ACCOUNTS_RECEIVABLE__payment_deadline',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '請求書生成日',accessor: 'ACCOUNTS_RECEIVABLE__invoice_process_pdf_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '請求金額',accessor: 'ACCOUNTS_RECEIVABLE__invoice_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '変更後請求金額',accessor: 'ACCOUNTS_RECEIVABLE__accounts_receivable_sales',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金合計額',accessor: 'ACCOUNTS_RECEIVABLE__receivable_collect_total_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '残額',accessor: 'ACCOUNTS_RECEIVABLE__receivable_uncollect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金履歴',accessor: 'actions_1',headerClassName:'text-center',className:'text-center',width:120,minWidth:50, sortable : false},
    { Header: '入金メモ',accessor: 'ACCOUNTS_RECEIVABLE__accounts_receivable_memo',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50, sortable : false},
    { Header: '督促フラグ',accessor: 'actions_payment_urge',headerClassName:'text-center',className:'text-center',width:120,minWidth:50, sortable : false},
    { Header: '入金',accessor: 'TEMP__sum_type_0',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '銀行１',accessor: 'TEMP__sum_type_0_1',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '銀行２',accessor: 'TEMP__sum_type_0_2',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '銀行３',accessor: 'TEMP__sum_type_0_3',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '振込手数料',accessor: 'TEMP__sum_type_1',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '調整金額',accessor: 'TEMP__sum_type_2',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '雑収入',accessor: 'TEMP__sum_type_3',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: 'その他',accessor: 'TEMP__sum_type_4',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '売上減額',accessor: 'TEMP__sum_type_5',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '雑損失',accessor: 'TEMP__sum_type_6',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '仮受金',accessor: 'TEMP__sum_type_7',headerClassName:'text-center',className:'text-right text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '最終更新情報',accessor: '__JOIN_accounts_receivable_update',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '売掛金管理',
      add_url: '',
      //search_url: '/api/accountsreceivable',
      search_url: '/api/accountsreceivable/unlimit', // #1168-2021.7.15

      header_md:"3",

      REQUEST__request_natural_id: "",
      landmark_branch: "",
      SECURITY_DEPOSIT__refund_stat: "",
      actions_1: "",

      column: this.default_column,
      detail_search:false,
      show_detail_search_field:false,
      valid: true,

      with_all_check: true,
      unique_key:"ACCOUNTS_RECEIVABLE__invoice_natural_id",
      
      checkbox_field_in_table:true,
      searchData:{
        values:{
          accounts_receivable_status : ["0","1","2","3","4"],
          accounts_receivable_collection_flag : ["0"],
        },
        errors:{},
        requiredData:{}
      },
      executionData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      landmark_user:[],
      user_list_for_lastupdate:[],
      listCsvData : [],
      dialogPaymentUrgeData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      auto_scroll:true,
    });

    this.dialogCsvDownload = React.createRef();
    this.dialogPaymentUrge = React.createRef();
    this.dialogMarkReceivedItemsAsCollected = React.createRef();
    this.dialogMarkReceivedItemsAsDepositHistory = React.createRef();
    this.dialogCustomerCsvDownload = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.validateExecCallback = this.validateExecCallback.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list_for_lastupdate = OptionConvert.optionsById(res.Data)
      const user_list = res.Data.map((user)=>{
        return {value:user.id, label:user.name}
      })
      this.setState({
        landmark_user:user_list,
        user_list_for_lastupdate
      }, () => {
        this.search()
      });
    })

    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })

    Request.get("/api/customer",{without_limit:true}, res => {
      const customerList = res.Data.map(element=>{
        return {
          value:element.ulid,
          label:element.customer_name
        }
      })
      this.setState({customerList});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  search = (refreshTaskFlag = false) => {
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      {
        ...searchParmas,
        invoice_customer_ulid : searchParmas.invoice_customer_name ? undefined : searchParmas.invoice_customer_ulid
      }
      , res => {
        // console.log(res.Data)
        const estimateList = res.data.map(item => item.estimate_id).join(",");
        // 会計テーブルから顧客の仮受金合計（残額）取得
        Request.get(`/api/accounts/search`, { estimate_ids : estimateList } , logs => {
          // console.log(logs.data);
          this.setState({
            data: this.dataMap(res.Data, logs.data),
            paging: {
              "index": parseInt(searchParmas["pager_index"]),
              "limit": parseInt(searchParmas["pager_limit"])
            },  
            searched_data : res.Data,
            executionData: {
              ...this.state.executionData,
              values: {
                ...this.state.executionData.values,
                exec_action: null
              }
            },
            checkedItems: [],
            accountsLogs : logs.data
          });
        })
    })

    this.searchByCustomer();

    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }

  // ページング後、stateを更新
  reloadBaseData (baseData,　pager=this.state.paging) {
    const estimateList = baseData.map(item => item.estimate_id).join(",");
    // 会計テーブルから顧客の仮受金合計（残額）取得
    Request.get(`/api/accounts/search`, { estimate_ids : estimateList } , logs => {
      let conv_data = this.dataMap(baseData,logs.data);
      var all_checked = true;
      conv_data.map(d=>{
          if ( d.checked==undefined ) {
              all_checked = false;
          }
      })

      this.setState({
          data: conv_data,
          paging:pager,
          all_check_status: all_checked,
          accountsLogs : logs.data,
          searched_data : baseData,
      }, () => {this.reloaded();});

    })
  }

  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        // console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }
  pageChangeHandle( customTable ){
    super.pageChangeHandle(customTable);
    return ;
  }
  // ListBaseUnlimit::reloaded override
  reloaded() {
    this.allStateClear();
  }

  searchByCustomer = () => {
    Request.get("/api/accountsreceivable/customer",{}, res => {
      const accountsReceivableCustomerList = res.Data;
      const totalUncollectAmt = accountsReceivableCustomerList.reduce((accumulator, currentValue)=>{
        return accumulator + currentValue.receivable_uncollect_amt || 0;
      }, 0)
      this.setState({accountsReceivableCustomerList, totalUncollectAmt});
    })
  }
  
  validateCallbackForMemo(newData, prop, key){
    this.setState({
      data : [
        ...this.state.data.slice(0, key),
        {
          ...this.state.data[key],
          ACCOUNTS_RECEIVABLE__accounts_receivable_memo : {
            ...this.state.data[key].ACCOUNTS_RECEIVABLE__accounts_receivable_memo,
            props : {
              ...this.state.data[key].ACCOUNTS_RECEIVABLE__accounts_receivable_memo.props,
              rootData : newData
            }
          }
        },
        ...this.state.data.slice(key+1),
      ]
    })
    if(Object.keys(newData.errors).length > 0){
      return;
    }
    const originMemo = this.state.data[key].ACCOUNTS_RECEIVABLE__accounts_receivable_memo.props.rootData.values.accounts_receivable_memo;
    if ( originMemo == newData.values.accounts_receivable_memo 
      || (originMemo == null && newData.values.accounts_receivable_memo == "")) {
      return;
    }

    const params = {
      ...prop,
      accounts_receivable_memo : newData.values.accounts_receivable_memo
    }

    // update 入金メモ
    Request.put('/api/accountsreceivable/update', params, res => {
      // this.search() // メモ更新時は再検索しない

      // this.search()を呼ばないことによりローカル環境の更新レコードに対するupdate_timestampが
      // 更新されず、MSG_ERR_804が発生するため、
      // 手動でローカルデータのupdate_timestampを明示的に更新する
      var searched_data = this.state.searched_data
      searched_data[key].update_timestamp = res.Data.update_timestamp
      searched_data[key].accounts_receivable_memo = res.Data.accounts_receivable_memo

      const logs = this.state.accountsLogs ? this.state.accountsLogs : "";
      this.setState({
        data: this.dataMap(searched_data, logs),
        searched_data : searched_data
      }, () => {});
    });
  }

  updateMemo(e, prop){
    const params = {
      ...prop,
      accounts_receivable_memo : e.target.value
    }

    // update 入金メモ
    Request.put('/api/accountsreceivable/update', params, res => {
      this.search()
    });
  }

  validateCallback(newData, callback=()=>{}){
    const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.invoice_customer_ulid)>-1)
    ? {
      invoice_customer_ulid: newData.values.invoice_customer_ulid,
      invoice_customer_name: undefined
    } : {
//      invoice_customer_ulid: newData.values.invoice_customer_ulid,
      invoice_customer_ulid: undefined,
      invoice_customer_name: newData.values.invoice_customer_ulid
    }

    this.setState({
      searchData:{
        ...newData,
        values : {
          ...newData.values,
          ...customerParam
        }
      }
    }, ()=>callback())
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.user_list_for_lastupdate;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data,logs="") {
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}
      // console.log(prop)
      return {
        id: prop.id,
        ulid : prop.ulid,
        estimate_id: prop.estimate_id,
        sales_receipt_mismatch: logs[prop.estimate_id]?.is_match ?? false,
        receipt_total: logs[prop.estimate_id]?.receipt_total ?? 0,
        sales_total: logs[prop.estimate_id]?.sales_total ?? 0,
        loan_total: logs[prop.estimate_id]?.loan_total ?? 0,
        accounts_receivable_status : prop.accounts_receivable_status,
        accounts_receivable_collection_flag : prop.accounts_receivable_collection_flag,
        update_timestamp: prop.update_timestamp,
        invoice_amt: prop.invoice_amt,
        receivable_collect_total_amt: prop.receivable_collect_total_amt,
        receivable_uncollect_amt: prop.receivable_uncollect_amt,
        accounts_receivable_sales: prop.accounts_receivable_sales,
        customer_id: prop.customer_id,
        customer_natural_id: prop.customer_natural_id,
        customer_branch_id: prop.customer_branch_id,
        customer_branch_natural_id: prop.customer_branch_natural_id,
        user_branch_id: prop.user_branch_id,
        user_branch_natural_id: prop.user_branch_natural_id,
        invoice_natural_id: prop.invoice_natural_id,
        ACCOUNTS_RECEIVABLE__invoice_natural_id : prop.invoice_natural_id,
        ___JOIN_client_master : (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />),
        PROJECT__site_name : prop.site_name,
        ___JOIN_accounts_receivable_status : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_accounts_receivable_status', prop)}} />,
        ACCOUNTS_RECEIVABLE__invoice_payment_finish_date : Format.format_date(prop.invoice_payment_finish_date),
        ACCOUNTS_RECEIVABLE__payment_deadline : Format.format_date(prop.payment_deadline),
        ACCOUNTS_RECEIVABLE__invoice_process_pdf_date : Format.format_date(prop.invoice_process_pdf_date),
        ACCOUNTS_RECEIVABLE__invoice_amt : Format.comma_delimited(prop.invoice_amt, "円"),
        ACCOUNTS_RECEIVABLE__accounts_receivable_sales : Format.comma_delimited(prop.accounts_receivable_sales, "円"),
        ACCOUNTS_RECEIVABLE__receivable_collect_total_amt : Format.comma_delimited(prop.receivable_collect_total_amt, "円"),
        ACCOUNTS_RECEIVABLE__receivable_uncollect_amt : Format.comma_delimited(prop.receivable_uncollect_amt, "円"),
        ACCOUNTS_RECEIVABLE__accounts_receivable_collection_flag : prop.accounts_receivable_collection_flag == 0 ? "未回収" : "回収済み",
        actions_1 : 
          <>
            <ButtonWithRole 
              button_id={"BTN_H1_01_05050"}
              size="sm"
              onClick={() => {this.props.history.push(`/accountsreceivable/${prop.ulid}`)}}
            >
              入金履歴
            </ButtonWithRole>
          </>
        ,
        ACCOUNTS_RECEIVABLE__accounts_receivable_memo : (
          <InputText
            key={prop.invoice_natural_id}
            label='入金メモ'
            name='ACCOUNTS_RECEIVABLE__accounts_receivable_memo'
            labelOn={false}
            multiline={true}
            validateCallback={(newData) => this.validateCallbackForMemo(newData, prop, key)}
            validateType={'regist'}
            rootData={{
              values : {
                accounts_receivable_memo : prop.accounts_receivable_memo
              },
              errors : {},
              requiredData : {}
            }}
          />
        ),
        actions_payment_urge :
        <>
          <ButtonWithRole 
            size="sm"
            onClick={() => {this.updatePaymentUrgeFlag(prop)}}
            disabled={prop.customer_system_use_flag === 0}
          >
            {prop.payment_urge_flag ? "ON" : "OFF"}
          </ButtonWithRole>
        </>,
        TEMP__sum_type_0 : Format.comma_delimited(prop.sum_type_0, "円"),
        TEMP__sum_type_0_1 : Format.comma_delimited(prop.sum_type_0_1, "円"),
        TEMP__sum_type_0_2 : Format.comma_delimited(prop.sum_type_0_2, "円"),
        TEMP__sum_type_0_3 : Format.comma_delimited(prop.sum_type_0_3, "円"),
        TEMP__sum_type_1 : Format.comma_delimited(prop.sum_type_1, "円"),
        TEMP__sum_type_2 : Format.comma_delimited(prop.sum_type_2, "円"),
        TEMP__sum_type_3 : Format.comma_delimited(prop.sum_type_3, "円"),
        TEMP__sum_type_4 : Format.comma_delimited(prop.sum_type_4, "円"),
        TEMP__sum_type_5 : Format.comma_delimited(prop.sum_type_5, "円"),
        TEMP__sum_type_6 : Format.comma_delimited(prop.sum_type_6, "円"),
        TEMP__sum_type_7 : Format.comma_delimited(prop.sum_type_7, "円"),
        __JOIN_accounts_receivable_update : <div dangerouslySetInnerHTML={{__html:Definition.item('__JOIN_accounts_receivable_update', prop_tmp)}} />,
        // 1674 ANDPAD連携用データ
        register_type : prop.register_type,
        ex_andpad_system_id : prop.ex_andpad_system_id,
        ex_andpad_use_flag : prop.ex_andpad_use_flag,
        ex_andpad_access_token_key : prop.ex_andpad_access_token_key,
        ex_andpad_quote_file_flag : prop.ex_andpad_quote_file_flag,
        ex_andpad_estimate_delete_flag : prop.ex_andpad_estimate_delete_flag,
        ex_andpad_plotting_delete_flag : prop.ex_andpad_plotting_delete_flag,
        ex_andpad_quote_delete_flag : prop.ex_andpad_quote_delete_flag,
      }
    });
  }

  updatePaymentUrgeFlag(prop){
    this.setState({
      dialogPaymentUrgeData : {
        ...this.state.dialogPaymentUrgeData,
        values : prop
      }
    }, () => {
      this.dialogPaymentUrge.current.show();
    })
  }

  search_params() {
    const {values} = this.state.searchData

    return values&&Object.keys(values).reduce((acc, key)=>{
      acc[key] = values[key]
      return acc
    },{})
  }

  validateExecCallback(newData, callback=()=>{}){
    this.setState({
      executionData:{
        ...this.state.executionData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputText
            label='請求ID'
            name='ACCOUNTS_RECEIVABLE__invoice_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputSelect
            label="顧客会社名"
            labelOn={true}
            name="ACCOUNTS_RECEIVABLE__invoice_customer_ulid"
            options={this.state.customerList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
            searchStartLength={2}
          />
        </Col>
        <Col md="3">
          <InputText
            label='現場名'
            name='PROJECT__site_name'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='現場名（カナ）'
            name='PROJECT__site_name_kana'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='工事番号'
            name='PROJECT__construction_number'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='市区町村'
            name='PROJECT__site_city'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='番地（町名以降）'
            name='PROJECT__site_address'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputSelect label="ランドマーク支店"
            name="USER_BRANCH__user_branch_natural_id"
            labelOn={true} 
            validateCallback={this.validateCallback} 
            options={this.state.landmark_user_branch}
            enterSearch={true}
            enterCallback={this.searchWithPageIndex}
            rootData={this.state.searchData} />
        </Col>
        <Col md="3">
          <InputDatetime
            label='回収完了日（FROM）'
            name='ACCOUNTS_RECEIVABLE__receivable_collect_finish_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='回収完了日（TO）'
            name='ACCOUNTS_RECEIVABLE__receivable_collect_finish_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='支払期限日（FROM）'
            name='ACCOUNTS_RECEIVABLE__payment_deadline_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='支払期限日（TO）'
            name='ACCOUNTS_RECEIVABLE__payment_deadline_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='入金履歴登録日（FROM）'
            name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='入金履歴登録日（TO）'
            name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputNumber
            label='請求金額（FROM）'
            name='ACCOUNTS_RECEIVABLE__invoice_amt_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
            size={12}
          />
        </Col>
        <Col md="3">
          <InputNumber
            label='請求金額（TO）'
            name='ACCOUNTS_RECEIVABLE__invoice_amt_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
            size={12}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='請求締日（FROM）'
            name='INVOICE__invoice_closing_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='請求締日（TO）'
            name='INVOICE__invoice_closing_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='口座番号'
            name='CUSTOMER_BRANCH__invoice_bank_account_number'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_accounts_receivable_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>        
        <Col md="3">
          <Col md="12">
            <InputCheckBox
              label='売掛金回収状況'
              name='ACCOUNTS_RECEIVABLE__accounts_receivable_status'
              labelOn={true}
              validateCallback={this.validateCallback}
              options={cst_accounts_receivable_status}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </Col>
          <Col md="12" className="mt-3">
            <InputCheckBox
              label='回収済フラグ'
              name='ACCOUNTS_RECEIVABLE__accounts_receivable_collection_flag'
              labelOn={true}
              validateCallback={this.validateCallback}
              options={cst_accounts_receivable_collection_action}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </Col>
        </Col>
      </>
    );
  }
  add_field_cols() {
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
    <>
        <Col md="6"></Col>
        <Col md="3">
          <Row>
            <Col md="12">
              <div className="float-right">
                売掛金残高：{Format.comma_delimited(this.state.totalUncollectAmt, "円")}
              </div>
            </Col>
            <Col md="12">
              <ButtonWithRole 
                // button_id={""}
                onClick={() => {
                  this.setState({
                    dialogTitle : "顧客別残高CSV出力",
                  }, () => {
                    this.dialogCustomerCsvDownload.current.show()
                  })
                }}
                className="float-right"
                size="sm"
              >
                顧客別残高CSV出力
              </ButtonWithRole>
            </Col>
          </Row>
        </Col>
    </>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<></>);
  }

  getButtonIdByExecutionType(executionType) {
    switch(executionType){
      case "入金履歴を登録する":
      return "BTN_H1_01_05140"
      case "回収済にする":
      return "BTN_H1_01_05141"
      default:
      return undefined
    }
  }

  async onClickExecButton() {

    if(!this.validate()){
      return;
    }
    
    switch (this.state.executionData.values.exec_action) {
      case "入金履歴を登録する":
        const length = this.state.checkedItems.filter((c) => c.accounts_receivable_collection_flag).length
        if(length > 0){
          this.props.alertModal.current.confirmCheck({
            title: "入金履歴を登録できません",
            messageNo: 2617,
            closeBtn: false
          }, ()=>{
            this.search();
          }, false)
        }else{
          this.dialogMarkReceivedItemsAsDepositHistory.current.show();
        }
        break;
      case "回収済にする":
        this.dialogMarkReceivedItemsAsCollected.current.show();
        break;
      default:
        return
    }
    // this.allStateClear();
  }

  checkbox_field_cols(){
    const buttonIdByExecutionType = this.getButtonIdByExecutionType(this.state.executionData.values.exec_action)
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
      <>
        <Col md='3'>
          <Label for="" className="search-text-order">チェックした確定見積について</Label>
          <InputSelect
            label='処理'
            name='TEMP__exec_action'
            options={[
              {value:'入金履歴を登録する', label:'入金履歴を登録する'},
              {value:'回収済にする', label:'回収済にする'},
            ]}
            rootData={this.state.executionData}
            validateCallback={this.validateExecCallback} 
          />
        </Col>
        <Col md='3'>
          {this.state.checkedItems.length > 10 && 
          <div style={{color:"red", textAlign: "right"}}>{GetMessage(2606)}</div>
          }
          <ButtonWithRole 
            button_id={buttonIdByExecutionType}
            onClick={() => this.onClickExecButton()}
            disabled={!buttonIdByExecutionType || this.state.checkedItems.length <= 0 || this.state.checkedItems.length > 10}
            className="float-right"
          >
           実行
          </ButtonWithRole>
        </Col>
        <Col md='3'>
          <ButtonWithRole 
              button_id={"BTN_H1_01_05030"}
              onClick={() => {
                this.setState({
                  dialogTitle : "一覧CSV出力",
                }, () => {
                  this.dialogCsvDownload.current.show()
                })
              }}
              className="float-center"
          >
            一覧CSV出力
          </ButtonWithRole>
        </Col>
        <Col md='3'>
          <ButtonWithRole 
            button_id={"BTN_H1_01_05040"}
            onClick={() => {
              this.setState({
                dialogTitle : "入金履歴CSV出力"
              }, () => {
                this.dialogCsvDownload.current.show()
              })
            }}
            className="float-center"
          >
            入金履歴CSV出力
          </ButtonWithRole>
        </Col>
      </>
    );
  }
  dialog_defines() {
    return (
      <>
        <DialogCsvDownload
          ref={this.dialogCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          user_list = {this.state.user_list_for_lastupdate}
          searched_data = {this.state.searched_data}
          search_params = {() => this.search_params()}
          positive={true}
          default_footer={true}
        />
        <DialogCustomerCsvDownload
          ref={this.dialogCustomerCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          searched_data = {this.state.accountsReceivableCustomerList}
          positive={true}
          default_footer={true}
        />
        <DialogPaymentUrge
          ref={this.dialogPaymentUrge} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          data={this.state.dialogPaymentUrgeData}
          positive={true}
          refreshCallback={this.search}
        />
        <DialogMarkReceivedItemsAsCollected
          ref={this.dialogMarkReceivedItemsAsCollected} 
          {...this.props}
          checkedItems={this.state.checkedItems}
          // dialogTitle = {this.state.dialogTitle}
          // data={this.state.dialogPaymentUrgeData}
          data={this.state.checkedItems}
          logData={this.state}
          positive={true}
          default_footer={true}
          refreshCallback={this.search}
        />
        <DialogMarkReceivedItemsAsDepositHistory
          ref={this.dialogMarkReceivedItemsAsDepositHistory} 
          {...this.props}
          checkedItems={this.state.checkedItems}
          accountsLogs={this.state.accountsLogs}
          // dialogTitle = {this.state.dialogTitle}
          // data={this.state.dialogPaymentUrgeData}
          data={this.state.checkedItems}
          positive={true}
          default_footer={true}
          refreshCallback={this.search}
        />
      </>
    );
  }    
}

export default List;


export class DialogCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.getListCsv = this.getListCsv.bind(this)
    this.getDetailCsv = this.getDetailCsv.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
        user_list : this.props.user_list,
        dialogData : {
          values : {
            extention_remind_send_flag : "",
            receivable_collect_date_from : moment().add(-1, "days").format("YYYY-MM-DDT00:00:00"),
            receivable_collect_date_to : moment().add(-1, "days").format("YYYY-MM-DDT23:59:59"),
          },
          errors: {
            ...this.state.dialogData.errors
          }, 
          requiredData :{
            receivable_collect_date_from:[GetMessage(2024)],
            receivable_collect_date_to:[GetMessage(2024)],
          }
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  async getListCsv(){
    const search_params = {
      ...this.props.search_params()
    }
    const searched_data = await new Promise((resolve, reject)=> {
      Request.get(`/api/accountsreceivable/csv`, search_params , res => {
        resolve(res.Data)
      })
    })

    const distinctReceivable = searched_data.filter((detail, index, self) =>
      index === self.findIndex((t) => (
        t.id === detail.id
      ))
    )
    const csvData = this.makeCsv(distinctReceivable, searched_data)
    return csvData
  }

  getDetailCsv() {
    const params = {
      receivable_collect_date_from : this.state.dialogData.values.receivable_collect_date_from,
      receivable_collect_date_to : this.state.dialogData.values.receivable_collect_date_to,
      receivable_collect_user_id : this.state.dialogData.values.receivable_collect_user_id,
    }
    return new Promise(async (resolve, reject) => {
      const accounts_receivable = await new Promise((resolve, reject)=> {
        Request.get(`/api/accountsreceivable/csv`, params , res => {
          resolve(res.Data)
        })
      })

      const distinctReceivable = accounts_receivable.filter((detail, index, self) =>
        index === self.findIndex((t) => (
          t.id === detail.id
        ))
      )
      console.log("distinctReceivable ", distinctReceivable)

      const csvData = this.makeCsv(distinctReceivable, accounts_receivable)
      resolve(csvData)
    })
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  makeCsv(distinctReceivable, detailsList){
    const csvData = distinctReceivable.reduce((acc, data) => {
      const updateUser = this.props.user_list.find((user) => user.id === data.lastupdate_user_id)

      const details = detailsList.filter((detail)=> {
        return detail.id === data.id
      })

      let detailCsv = []
      let sumByType = [0,0,0,0,0,0,0,0];
      let sumByBank = ["",0,0,0]
      let skip = 0;
      for(let i=0; i<10; i++){
        const detail = details[i];
        
        if(detail){
          const detailUpdateUser = this.props.user_list.find((user) => user.id === detail.receivable_collect_user_id)
          detailCsv = detailCsv.concat([
            this.isNullOrUndefined(detail.receivable_collect_date) ?  "" : moment(detail.receivable_collect_date).format("YYYY/MM/DD HH:mm"),
            this.isNullOrUndefined(detail.receivable_collect_amt) ? "" : detail.receivable_collect_amt,
            this.isNullOrUndefined(detail.receivable_collect_type) ? "" : detail.receivable_collect_type,
            this.isNullOrUndefined(detail.receivable_collect_type) ? "" : FormatCode.decode("cst_receivable_collect_type", detail.receivable_collect_type) ,
            this.isNullOrUndefined(detail.receivable_collect_memo) ? "" : detail.receivable_collect_memo,
            detailUpdateUser ? detailUpdateUser.label : "",
          ])
          let receivable_collect_type = detail.receivable_collect_type == 8 ? 3 : detail.receivable_collect_type;
          sumByType[receivable_collect_type] = sumByType[receivable_collect_type] + detail.receivable_collect_amt;
          sumByBank[detail.receivable_collect_bank_type] = sumByBank[detail.receivable_collect_bank_type] + detail.receivable_collect_amt;
        } else {
          detailCsv = detailCsv.concat([
            "",
            "",
            "",
            "",
            "",
            "",
          ])
        }
      }
      // skip分枠を追加
      for(let c=0; c<= skip ; c++){
        detailCsv = detailCsv.concat([
          "",
          "",
          "",
          "",
          "",
          "",
        ])
      }

      acc.push([
        this.isNullOrUndefined(data.invoice_natural_id) ? "" : data.invoice_natural_id,
        this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name,
        this.isNullOrUndefined(data.customer_branch_name) ? "" : data.customer_branch_name,
        this.isNullOrUndefined(data.customer_user_name) ? "" : data.customer_user_name,
        this.isNullOrUndefined(data.customer_branch_tel) ? "" : data.customer_branch_tel,
        this.isNullOrUndefined(data.site_name) ? "" : data.site_name,
        this.isNullOrUndefined(data.accounts_receivable_status) ? "" : data.accounts_receivable_status,
        this.isNullOrUndefined(data.receivable_collect_finish_date) ? "" : moment(data.receivable_collect_finish_date).format("YYYY/MM/DD HH:mm"),
        this.isNullOrUndefined(data.payment_deadline) ? "" : moment(data.payment_deadline).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_amt) ? "" : data.invoice_amt,
        this.isNullOrUndefined(data.invoice_amt) ? "" : data.accounts_receivable_sales,
        this.isNullOrUndefined(data.receivable_collect_total_amt) ? "" : data.receivable_collect_total_amt,
        this.isNullOrUndefined(data.receivable_uncollect_amt) ? "" : data.receivable_uncollect_amt,
        this.isNullOrUndefined(data.accounts_receivable_memo) ? "" : data.accounts_receivable_memo,
        this.isNullOrUndefined(sumByType[0]) ? "" : sumByType[0],
        this.isNullOrUndefined(sumByBank[1]) ? "" : sumByBank[1],
        this.isNullOrUndefined(sumByBank[2]) ? "" : sumByBank[2],
        this.isNullOrUndefined(sumByBank[3]) ? "" : sumByBank[3],
        this.isNullOrUndefined(sumByType[1]) ? "" : sumByType[1],
        this.isNullOrUndefined(sumByType[2]) ? "" : sumByType[2],
        this.isNullOrUndefined(sumByType[3]) ? "" : sumByType[3],
        this.isNullOrUndefined(sumByType[4]) ? "" : sumByType[4],
        this.isNullOrUndefined(sumByType[5]) ? "" : sumByType[5],
        this.isNullOrUndefined(sumByType[6]) ? "" : sumByType[6],
        this.isNullOrUndefined(sumByType[7]) ? "" : sumByType[7],
        this.isNullOrUndefined(data.update_timestamp) ? "" : moment(data.update_timestamp).format("YYYY/MM/DD HH:mm"),
        updateUser ? updateUser.label : "",
        this.isNullOrUndefined(data.user_branch_name) ? "" : data.user_branch_name,
        this.isNullOrUndefined(data.invoice_note) ? "" : data.invoice_note,
        this.isNullOrUndefined(data.payment_user_memo) ? "" : data.payment_user_memo,
        ...detailCsv
      ])
      return acc
    }, [[...ACCOUNTS_RECEIVABLE_LIST.HEADER]])

    return this.wrappingQuote(csvData);
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      this.props.dialogTitle === "入金履歴CSV出力" ? 
      <>
        <Row>
          <Col md="6">
            <InputDatetime
              label='入金日（FROM）'
              name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
          <Col md="6">
            <InputDatetime
              label='入金日（TO）'
              name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <InputSelect
              label='入金履歴登録者'
              name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_user_id'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              options={this.state.user_list}
              isSearchable={true}
              validateType={'search'}
            />
          </Col>
        </Row>
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }
            const csvData = await this.getDetailCsv();
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`accounts_receivable_collect_history_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
      :
      <> 
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            const csvData = await this.getListCsv();
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`accounts_receivable_list_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogPaymentUrge extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
  }

  componentDidMount() {
    Request.get("/api/landmark/lastupdate",{}, res => {
      this.setState({
        user_list : res.Data
      });
    })
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      this.setState({
        title: `${this.props.data.values.payment_urge_flag == 0 ? '督促フラグをＯＮにします。' : '督促フラグをＯＦＦにします。'}よろしいですか？`,
        data:this.props.data
      })
    }
  }

  async handleClickPositive() {
    const params = {
      ...this.state.data.values,
      payment_urge_flag : this.state.data.values.payment_urge_flag == 1 ? 0 : 1
    }

    // ONになる場合、督促状を自動送信する
    if(params.payment_urge_flag === 1){
      const {
        estimate_natural_id,
        request_natural_id,
        customer_user_natural_id,
        customer_branch_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        project_natural_id,
        invoice_natural_id,
        invoice_amt,
        quote_available_start_date,
        quote_available_end_date,
        request_type,
        invoice_closing_date, 
        invoice_process_pdf_date, 
        payment_deadline,
        receivable_collect_total_amt,
        receivable_uncollect_amt,
        request_user_branch_natural_id:user_branch_natural_id
      } = params
      console.log(params);
      Request.setProgress(10)
      const invoiceCommon = await Request.getInvoiceCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        request_natural_id,
        project_natural_id,
        invoice_natural_id,
        invoice_process_pdf_date,
        estimate_natural_id,
        quote_available_start_date,
        quote_available_end_date,
        request_type,
        payment_deadline,
        invoice_closing_date,
        invoice_amt,
        user_branch_natural_id
      })
  
      const object_each_data = {
        ACCOUNTS_RECEIVABLE__invoice_amt: invoice_amt,
        ACCOUNTS_RECEIVABLE__payment_deadline: payment_deadline,
        ACCOUNTS_RECEIVABLE__receivable_collect_total_amt: receivable_collect_total_amt,
        ACCOUNTS_RECEIVABLE__receivable_uncollect_amt:receivable_uncollect_amt,
      }
  
      Request.setProgress(30)
      const mailData = await new Promise((resolve, reject)=>{
        const mailUrl = '/api/pout/G10_MAIL'
        const mailParams = {
          format_url:GoogleDrive.getFormatUrl(format_url.G10_MAIL),
          send_destination_type:0, // 元請けのみ
          ...invoiceCommon,
          object_each_data,
          ESTIMATE__latest_pdf_quote_url : null,
        }
        Request.post(mailUrl, mailParams, res=>{
          resolve(res)
        }, err=>{
          reject(err)
        })
      })
      Request.setProgress(70)
      
      const sendMailUrl = '/api/send/AUTOMAIL';
      Request.post(sendMailUrl, mailData.Data, res=>{
        // 督促フラグ更新
        Request.put('/api/accountsreceivable/update', params, res => {
          // window.open(`https://mail.google.com/mail/u/0/#drafts`);
          this.props.alertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: [2417,2543],
            closeBtn: false
            }, ()=>{
              this.props.refreshCallback()
              this.toggleModal();
            }, false)	
        });
      }, err=>{}, () => {
          Request.setProgress(0)
      })
    } else {
      // 督促フラグをOFFにする場合、督促フラグのみ更新
      Request.put('/api/accountsreceivable/update', params, res => {
        this.props.alertModal.current.confirmCheck({
          title: "処理完了",
          messageNo: [2417],
          closeBtn: false
          }, ()=>{
            this.props.refreshCallback()
            this.toggleModal();
          }, false)	
      });
    }
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return (
      <>
        <div>督促状フラグをONにする場合は督促メールが送信されます</div>
      </>
    );
  }
}

export class DialogCustomerCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.makeCsv = this.makeCsv.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
      });
    }
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  makeCsv(accountsReceivableList){
    const csvData = accountsReceivableList.reduce((acc, data) => {

      acc.push([
        this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name,
        this.isNullOrUndefined(data.invoice_amt) ? 0 : data.invoice_amt,
        this.isNullOrUndefined(data.accounts_receivable_sales) ? 0 : data.accounts_receivable_sales,
        this.isNullOrUndefined(data.receivable_collect_total_amt) ? 0 : data.receivable_collect_total_amt,
        this.isNullOrUndefined(data.receivable_uncollect_amt) ? 0 : data.receivable_uncollect_amt,
        this.isNullOrUndefined(data.sum_type_0) ? 0 : data.sum_type_0,
        this.isNullOrUndefined(data.sum_type_0_1) ? 0 : data.sum_type_0_1,
        this.isNullOrUndefined(data.sum_type_0_2) ? 0 : data.sum_type_0_2,
        this.isNullOrUndefined(data.sum_type_0_3) ? 0 : data.sum_type_0_3,
        this.isNullOrUndefined(data.sum_type_1) ? 0 : data.sum_type_1,
        this.isNullOrUndefined(data.sum_type_2) ? 0 : data.sum_type_2,
        this.isNullOrUndefined(data.sum_type_3) ? 0 : data.sum_type_3,
        this.isNullOrUndefined(data.sum_type_6) ? 0 : data.sum_type_6,
        this.isNullOrUndefined(data.sum_type_5) ? 0 : data.sum_type_5,
        this.isNullOrUndefined(data.sum_type_4) ? 0 : data.sum_type_4,
        this.isNullOrUndefined(data.sum_type_7) ? 0 : data.sum_type_7,
      ])
      return acc
    }, [[...ACCOUNTS_RECEIVABLE_LIST_PER_CUSTOMER.HEADER]])

    return this.wrappingQuote(csvData);
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <>
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            const csvData = await this.makeCsv(this.props.searched_data);
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`accounts_receivable_list_per_customer_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

// チェックしたものを回収済にする
export class DialogMarkReceivedItemsAsCollected extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: 'チェックした請求について回収済にします。よろしいですか？',
        dialogData : {
          values : {
            receivable_collect_finish_date : moment().add(-1, "days").format("YYYY-MM-DDT00:00:00"),
          },
          errors: {
          }, 
          requiredData :{
            receivable_collect_finish_date:[GetMessage(2024)],
          }
        }
      });
    }
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  bodyContent() {
    // console.log(this.state.data);
    // console.log(this.props.checkedItems);
    var accounts_receivable_count = this.props.checkedItems.filter(item => item.accounts_receivable_status == 2).length;
    var cancel_count = this.props.checkedItems.filter(item => item.accounts_receivable_status == 3).length;
    var part_cancel_count = this.props.checkedItems.filter(item => item.accounts_receivable_status == 4).length;
    var sales_receipt_mismatch_count = this.props.checkedItems.filter(item => item.sales_receipt_mismatch == false).length;
    var accounts_receivable_collection_count = this.props.checkedItems.filter(item => item.accounts_receivable_collection_flag == 1).length;
    // var loan_total_count = this.props.checkedItems.filter(item => item.loan_total == 0).length;
    var target_count = this.props.checkedItems.length - sales_receipt_mismatch_count - accounts_receivable_collection_count;
    // console.log("accounts_receivable_collection_count:"+accounts_receivable_collection_count)
    var has_zero_uncollect_amt = this.props.checkedItems.filter(item => item.receivable_uncollect_amt != 0).length > 0;
    return (
      <>
        <Container>
          {has_zero_uncollect_amt &&
            <p style={{ color: "red" }}>{GetMessage(2607)}</p>
          }
          <Row>
            <Col>処理対象　{target_count}件　回収済　{accounts_receivable_count}件　キャンセル　{cancel_count}件　一部キャンセル　{part_cancel_count}件　売上入金不一致　{sales_receipt_mismatch_count}件<br/>回収済フラグが回収済または売上と入金が不一致の場合は処理対象外のため、無視されます。<br/></Col>
          </Row>
          {/* <Row>
            <Col md="12">
              <InputDatetime
                label='回収済日付'
                name='ACCOUNTS_RECEIVABLE__receivable_collect_finish_date'
                labelOn={true}
                validateCallback={this.validateCallback}
                rootData={this.state.dialogData}
                validateType={'regist'}
                disabled={false}
                timeFormat={true}
                valid_threemonth={false}
              />
            </Col>
          </Row> */}
        </Container>
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>いいえ</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }
            
            // 売上と入金が同じ金額で、仮受金が0の場合、実行
            var target_account_receivables = this.props.checkedItems.filter(item => item.sales_receipt_mismatch && item.loan_total == 0);
            const params = {
              account_receivables: target_account_receivables,
              receivable_collect_finish_date: this.state.dialogData.values.receivable_collect_finish_date
            }
            Request.put('/api/accountsreceivable/collected/update', params, res => {
              this.handleClickPositive();
              this.setState({
                modal: false
              });
              this.props.refreshCallback();
            });
          }}>はい</Button>
        </div>
      </>
    );
  }
}

// チェックしたものの入金履歴を登録する
export class DialogMarkReceivedItemsAsDepositHistory extends DialogBase {
  
  constructor(props) {
    super(props);

    // initialize()でdialogData刃設定するのでここで設定する必要はないが
    // 一応こういうフィールドを使ってるという目安
    Object.assign(this.state, {
      user_list: [],
      dialogData : {
        values : {
          receivable_collect_date: null,
          receivable_collect_amt: null,
          receivable_collect_type: null,
          receivable_collect_bank_type: 0,
          receivable_collect_memo: null,
          extention_remind_send_flag: "",
          balance_all_flag: false,
        },
        errors : { // 読み込み段階でバリデーション空欄必須フィールドをエラー状態にしておく
          // receivable_collect_date:[GetMessage(2024)],　// 入金日は初期値を入れるので初期エラーなし
          receivable_collect_amt:[GetMessage(2024)],
          receivable_collect_type:[GetMessage(2024)],
        },
        requiredData: {
          receivable_collect_date:[GetMessage(2024)],
          receivable_collect_amt:[GetMessage(2024)],
          receivable_collect_type:[GetMessage(2024)],
        }
      },
      sub_regist_modal: false
    });

    this.validateCallback = this.validateCallback.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.regist = this.regist.bind(this);
    this.alertAndpadModal = React.createRef();
  }

  componentDidMount() {
    Request.get("/api/landmark/lastupdate",{}, res => {
      this.setState({
        user_list : res.Data
      });
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: 'チェックした請求について入金履歴を登録します。よろしいですか？',
        dialogData : {
          ...this.state.dialogData,
        }
      });
    }
  }

  // dialog.show()時に呼び出される初期化関数
  initialize() {    
    // 入金日はダイアログを開いたタイミングの日時を指定
    this.setState({
      dialogData : {
        values : {
          receivable_collect_date: moment().add(-1, "days").format("YYYY-MM-DDT00:00:00"),
          receivable_collect_amt: null,
          receivable_collect_type: null,
          receivable_collect_bank_type: 0,
          receivable_collect_memo: null,
          extention_remind_send_flag: "",
          balance_all_flag: false
        },
        errors : { // 読み込み段階でバリデーション空欄必須フィールドをエラー状態にしておく
          // receivable_collect_date:[GetMessage(2024)],　// 入金日は初期値を入れるので初期エラーなし
          receivable_collect_amt:[GetMessage(2024)],
          receivable_collect_type:[GetMessage(2024)],
        },
        requiredData: {
          receivable_collect_date:[GetMessage(2024)],
          receivable_collect_amt:[GetMessage(2024)],
          receivable_collect_type:[GetMessage(2024)],
        }
      },
      sub_regist_modal: false,
      andpad_alert_estimates: []
    }, () => {});
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  validateCallback(newData, callback=()=>{}){
    // console.log(newData)
    // 残額すべてのチェックで動的に必須項目変更の要件に対応
    var balance_all_flag = newData.values.balance_all_flag;
    var required_data = balance_all_flag ? {
      receivable_collect_date:[GetMessage(2024)],
      receivable_collect_type:[GetMessage(2024)],
    } : {
      receivable_collect_date:[GetMessage(2024)],
      receivable_collect_amt:[GetMessage(2024)],
      receivable_collect_type:[GetMessage(2024)],
    }
    var errors = newData.errors;
    if (balance_all_flag) {
      delete errors.receivable_collect_amt;
    } else {
      // 残額すべてのチェックがOFFになった時　入金額に対するエラーを自前で判別する
      // InputNumberに対してバリデーションだけ再実行させるIFが現状なさそう
      if(!newData.values.receivable_collect_amt) {
        errors['receivable_collect_amt'] = [GetMessage(2024)];
      }
    }

    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData,
        requiredData: required_data,
        errors: errors
      }
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }
  // #1674 ANDPAD対応
  andpad_data_check(data,collectType,salesTotal,value,balance_all_flag){
    let andpad_alert_estimates = this.state.andpad_alert_estimates;
    const {ex_andpad_use_flag, 
          ex_andpad_access_token_key, 
          register_type, 
          ex_andpad_system_id,
          invoice_natural_id, 
          receivable_collect_total_amt,
          ex_andpad_estimate_delete_flag,
          ex_andpad_plotting_delete_flag,
          ex_andpad_quote_delete_flag
          } = data;

    const andpad_use_flag = ex_andpad_use_flag == 1 && 
                      ex_andpad_access_token_key != "" && 
                      ex_andpad_access_token_key != null &&
                      ex_andpad_system_id != "" && 
                      ex_andpad_system_id != null &&
                      parseInt(register_type) == 1 && 
                      ex_andpad_estimate_delete_flag == 0 && 
                      ex_andpad_plotting_delete_flag == 0 ? true : false;
    // console.log("andpad_use_flag ", andpad_use_flag)
    // console.log("data ", data)
                      
    // 残額全てにチェックが入っている場合
    if (balance_all_flag) {
      // 入金額合計が0
      if(andpad_use_flag && collectType == 5 && salesTotal > 0 && receivable_collect_total_amt == 0){
        andpad_alert_estimates.push(invoice_natural_id);
      }
    } else {
      if(andpad_use_flag && collectType == 5 && salesTotal == value){
        andpad_alert_estimates.push(invoice_natural_id);
      }
    }

    if (andpad_alert_estimates.length > 0) {
      this.setState({
        andpad_alert_estimates: andpad_alert_estimates
      }, ()=>{})
    }

  }

  regist() {
    // console.log(this.props.checkedItems)
    // 以下の条件を満たしている場合、登録可能
    const target_account_receivables = this.props.checkedItems.filter((item)=> {
      // console.log(item)
      const balance_all_flag = this.state.dialogData.values.balance_all_flag
      const collectType = this.state.dialogData.values.receivable_collect_type
      const salesTotal = item.sales_total;
      // 残額全てにチェックが入っている場合は、売上-入金の差額を割り出す
      const value = this.state.dialogData.values.receivable_collect_amt;

      if(!balance_all_flag){
        const receiptTotal = item.receivable_collect_total_amt;
        // 過売上減額：売上-売上取消-入力された売上取消 < 0
        const overSalesTotal = (salesTotal - value) < 0 ? true: false;
        // 過入金：売上-売上取消 > 入金-入金取消+追加入金
        const overReceiptTotal = (receiptTotal + value) > salesTotal ? true: false ;
        const overFlag = collectType == 5 ? overSalesTotal : overReceiptTotal;
        
        !overFlag && this.andpad_data_check(item, collectType, salesTotal, value, balance_all_flag)
        return !overFlag;
      }else{
        this.andpad_data_check(item, collectType, salesTotal, value, balance_all_flag)
      }
      return true;
    })


    // 以下の条件を満たしている場合、登録可能
    const params = {
      account_receivables: target_account_receivables,
      receivable_collect: {
        ...this.state.dialogData.values,
        receivable_collect_user_id : GsuiteAuth.get("id")
      }
    }
    // console.log(params)

    Request.put('/api/accountsreceivable/detail/collect/update', params, res => {
      if (res.Code == 816){
        this.props.alertModal.current.confirmCheck({
          title: res.data.message,
          messageNo: 2616,
          closeBtn: false
        }, ()=>{
          this.toggleSubRegistModal();
        }, false)
      }else{
        // console.log(this.state.andpad_alert_estimates)
        if (this.state.andpad_alert_estimates.length > 0) {
          // console.log("ANDPADアラートモーダルを表示")
          this.alertAndpadModal.current.toggleErrorModal(
            {
              estimate: this.state.andpad_alert_estimates,
            }
          );
        }else{
          this.toggleSubRegistModal();
          this.handleClickPositive();
          this.setState({
            modal: false
          });
          this.props.refreshCallback();
        }
      }
    });
  }

  toggleSubRegistModal(){
    this.setState({
      sub_regist_modal: !this.state.sub_regist_modal
    });
  }

  bodyContent() {
    // console.log(this.state.data);
    // console.log(this.props.checkedItems);
    const {
      balance_all_flag
    } = this.state.dialogData.values;
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.dialogData.values);
    const user = this.state.user_list.find(user => user.id == GsuiteAuth.get("id"));
    return (
      <>
        <Container>
          <Row>
            <Col><font color="red">回収済およびキャンセル、一部キャンセルまたは、すでに入金履歴が10件登録されている場合は、無視されます。</font></Col>
          </Row>
          <Row className="detail">
            <Col md="12">
              <Table>
                <tbody>
                  <tr>
                    <CustomTd label='入金日'
                        name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_date'
                        copy={false}
                        rootData={this.state.dialogData}
                        value={
                          <InputDatetime
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                            timeFormat={true}
                            disabled={false}
                          />
                        }
                    />
                  </tr>
                  <tr>
                    <CustomTd label='入金額'
                        copy={false}
                        value={
                          <Row>
                            <Col md="8">
                              <InputNumber
                                name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_amt'
                                rootData={this.state.dialogData}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                size={12}
                                unit="円"
                                disabled={balance_all_flag}
                              />
                            </Col>
                            <Col md="4">
                              <InputCheckBox
                                label='残額全て'
                                labelOn={false}
                                name="ESTIMATE__balance_all_flag" 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.dialogData}
                                validateType={'search'}
                                />
                            </Col>
                          </Row>
                        }
                    />
                  </tr>
                  <tr>
                    <CustomTd label='入金種別'
                      name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_type'
                      copy={false}
                      rootData={this.state.dialogData}
                      value={
                        <InputSelect
                          options={new_cst_receivable_collect_type}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          zIndex="99999"
                          isSearchable={true}
                        />
                      }
                    />
                  </tr>
                  <tr>
                    <CustomTd label='銀行種別'
                      name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_bank_type'
                      copy={false}
                      rootData={this.state.dialogData}
                      value={
                        <InputSelect
                          options={cst_receivable_collect_bank_type}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                          zIndex="99999"
                          isSearchable={true}
                          disabled={this.state.dialogData.values.receivable_collect_type !== 0}
                        />
                      }
                    />
                  </tr>                    
                  <tr>
                    <td class="subTitle">
                      延長リマインド通知 
                    </td>
                    <td>
                      <InputRadio
                          options={cst_extension_remind_send_flag_action}
                          labelOn={false}
                          name="ESTIMATE__extention_remind_send_flag" 
                          validateCallback={this.validateCallback} 
                          // checkedValue={1}
                          // uncheckedValue={0}
                          // disabled={this.state.dialogData.values.receivable_collect_type != 5}
                          rootData={this.state.dialogData}
                          />

                    </td>
                  </tr>

                  <tr>
                    <CustomTd label='入金履歴メモ'
                      name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_memo'
                      copy={false}
                      rootData={this.state.dialogData}
                      value={
                        <InputText multiline={true}
                          validateCallback={this.validateCallback} 
                          validateType='regist'
                        />
                      }
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label='入金履歴登録者'
                      name='ACCOUNTS_RECEIVABLE_DETAIL__receivable_collect_user_id'
                      copy={false}
                      value = {user ? user.name : ""}
                    />
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>いいえ</Button>
          <ButtonWithRole 
            button_id = {"BTN_H1_01_05142"}
            color="info" 
            onClick={() => {
              if(!this.validate(this.state.dialogData.errors)){
                return;
              }
              this.toggleSubRegistModal();
            }} className="float-right"
          >
            入金履歴追加
          </ButtonWithRole>
        </div>
        <Modal isOpen={this.state.sub_regist_modal} toggle={this.toggleSubRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSubRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">入金登録</h5>
          </div>
          <ModalBody>
            <p>入金登録をします。よろしいですか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={()=>{this.regist()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        <AlertAndpadModal
          ref={this.alertAndpadModal} 
          returnCallback={() => {
            this.toggleSubRegistModal();
            this.handleClickPositive();
            this.setState({
              modal: false
            });
            this.props.refreshCallback();
          }}
        />
      </>
    );
  }
}